import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Layout } from "../components/Layout";
import { api } from "../lib/api";
import { Wrench, Zap } from "lucide-react";
import { toast } from "sonner";

export default function RooftopServiceDrive() {
  const { rooftop_id } = useParams();
  const [rooftop, setRooftop] = useState(null);
  const [ros, setRos] = useState([]);

  useEffect(() => {
    api.get(`/rooftops/${rooftop_id}`).then((r) => setRooftop(r.data));
    api.get(`/service-drive/${rooftop_id}`).then((r) => setRos(r.data));
  }, [rooftop_id]);

  return (
    <Layout variant="rooftop" rooftopId={rooftop_id} rooftopName={rooftop?.name}>
      <div className="mb-6">
        <div className="flex items-center gap-2 text-[11px] uppercase tracking-wider text-slate-500 font-semibold">
          <Wrench size={12} /> Service drive
        </div>
        <h1 className="text-3xl font-bold text-navy mt-1">ROs with buy opportunity</h1>
        <p className="text-sm text-slate-500 mt-1 font-medium">Live ROs · vehicles under 100k mi / 5yrs old · positive equity gap flagged.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="service-drive-list">
        {ros.length === 0 && (
          <div className="md:col-span-2 xl:col-span-3 bg-white border border-slate-200 rounded-xl p-10 text-center text-sm text-slate-500">
            No positive-equity ROs in the drive right now.
          </div>
        )}
        {ros.map((v) => {
          const equity = v.comp_retail_avg - v.mmr_current - v.recon_estimate;
          return (
            <div key={v.vin} className="bg-white border border-slate-200 rounded-xl p-5 hover:border-freddy-red transition-colors">
              <div className="flex items-start justify-between mb-3">
                <div>
                  <div className="text-[10px] uppercase tracking-wider text-freddy-red font-bold">RO active</div>
                  <div className="font-bold text-navy mt-0.5">{v.year} {v.make} {v.model}</div>
                  <div className="text-xs text-slate-500">{v.trim} · {v.mileage.toLocaleString()} mi</div>
                </div>
                <div className="text-right">
                  <div className="text-[10px] uppercase tracking-wider text-slate-500 font-bold">Equity gap</div>
                  <div className="text-lg font-bold tabular text-verdict-strongText">+${equity.toLocaleString()}</div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-2 text-xs mb-3 pt-3 border-t border-slate-100">
                <div><div className="text-slate-500">MMR</div><div className="font-bold tabular">${v.mmr_current.toLocaleString()}</div></div>
                <div><div className="text-slate-500">Comp retail</div><div className="font-bold tabular">${v.comp_retail_avg.toLocaleString()}</div></div>
              </div>
              <button onClick={() => toast.success("BDC dispatched · customer engagement queued")}
                      data-testid={`dispatch-bdc-${v.vin}`}
                      className="w-full inline-flex items-center justify-center gap-1.5 bg-freddy-red hover:bg-freddy-redDark text-white text-xs font-bold py-2 rounded-md uppercase tracking-wider">
                <Zap size={12} /> Dispatch BDC
              </button>
            </div>
          );
        })}
      </div>
    </Layout>
  );
}
